// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = "/admin";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: "/login",
  privacy: "/privacy-policy",
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  dashboard: path(ROOTS_DASHBOARD, "/dashboard"),
  notification: path(ROOTS_DASHBOARD, "/notification"),
  profile: path(ROOTS_DASHBOARD, "/profile"),
  search: path(ROOTS_DASHBOARD, "/search"),

  blogs: {
    root: path(ROOTS_DASHBOARD, "/blogs"),
    list: path(ROOTS_DASHBOARD, "/blogs/list"),
    add: path(ROOTS_DASHBOARD, "/blogs/add"),
    edit: (id) => path(ROOTS_DASHBOARD, `/blogs/edit/${id}`),
    view: (id) => path(ROOTS_DASHBOARD, `/blogs/view/${id}`),
  },

  contacts: {
    root: path(ROOTS_DASHBOARD, "/contacts"),
    list: path(ROOTS_DASHBOARD, "/contacts/list"),
    add: path(ROOTS_DASHBOARD, "/contacts/add"),
    edit: (id) => path(ROOTS_DASHBOARD, `/contacts/edit/${id}`),
    view: (id) => path(ROOTS_DASHBOARD, `/contacts/view/${id}`),
  },

  manage: {
    root: path(ROOTS_DASHBOARD, "/manage"),
    list: path(ROOTS_DASHBOARD, "/manage/list"),
    add: path(ROOTS_DASHBOARD, "/manage/add"),
    faqs: path(ROOTS_DASHBOARD, "/manage/faqs/list"),
    edit: (id) => path(ROOTS_DASHBOARD, `/manage/edit/${id}`),
    view: (id) => path(ROOTS_DASHBOARD, `/manage/view/${id}`),
  },

  products: {
    root: path(ROOTS_DASHBOARD, "/products"),
    list: path(ROOTS_DASHBOARD, "/products/list"),
    add: path(ROOTS_DASHBOARD, "/products/add"),
    edit: (id) => path(ROOTS_DASHBOARD, `/products/edit/${id}`),
    view: (id) => path(ROOTS_DASHBOARD, `/products/view/${id}`),
  },

  orders: {
    root: path(ROOTS_DASHBOARD, "/orders"),
    list: path(ROOTS_DASHBOARD, "/orders/list"),
    add: path(ROOTS_DASHBOARD, "/orders/add"),
    edit: (id) => path(ROOTS_DASHBOARD, `/orders/edit/${id}`),
    view: (id) => path(ROOTS_DASHBOARD, `/orders/view/${id}`),
  },

  entries: {
    root: path(ROOTS_DASHBOARD, "/entries"),
    schools: {
      root: path(ROOTS_DASHBOARD, "/entries/schools"),
      list: path(ROOTS_DASHBOARD, "/entries/schools/list"),
      add: path(ROOTS_DASHBOARD, "/entries/schools/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/entries/schools/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/entries/schools/view/${id}`),
    },

    dresses: {
      root: path(ROOTS_DASHBOARD, "/entries/dresses"),
      list: path(ROOTS_DASHBOARD, "/entries/dresses/list"),
      add: path(ROOTS_DASHBOARD, "/entries/dresses/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/entries/dresses/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/entries/dresses/view/${id}`),
    },

    sizes: {
      root: path(ROOTS_DASHBOARD, "/entries/sizes"),
      list: path(ROOTS_DASHBOARD, "/entries/sizes/list"),
      add: path(ROOTS_DASHBOARD, "/entries/sizes/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/entries/sizes/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/entries/sizes/view/${id}`),
    },

    categories: {
      root: path(ROOTS_DASHBOARD, "/entries/categories"),
      list: path(ROOTS_DASHBOARD, "/entries/categories/list"),
      add: path(ROOTS_DASHBOARD, "/entries/categories/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/entries/categories/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/entries/categories/view/${id}`),
    },

    houses: {
      root: path(ROOTS_DASHBOARD, "/entries/houses"),
      list: path(ROOTS_DASHBOARD, "/entries/houses/list"),
      add: path(ROOTS_DASHBOARD, "/entries/houses/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/entries/houses/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/entries/houses/view/${id}`),
    },

    types: {
      root: path(ROOTS_DASHBOARD, "/entries/types"),
      list: path(ROOTS_DASHBOARD, "/entries/types/list"),
      add: path(ROOTS_DASHBOARD, "/entries/types/add"),
      edit: (id) => path(ROOTS_DASHBOARD, `/entries/types/edit/${id}`),
      view: (id) => path(ROOTS_DASHBOARD, `/entries/types/view/${id}`),
    },
  },
  users: {
    root: path(ROOTS_DASHBOARD, "/users"),
    list: path(ROOTS_DASHBOARD, "/users/list"),
    add: path(ROOTS_DASHBOARD, "/users/add"),
    edit: (id) => path(ROOTS_DASHBOARD, `/users/edit/${id}`),
    view: (id) => path(ROOTS_DASHBOARD, `/users/view/${id}`),
  },
};
